import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getSpecialPromotions } from "@store/Services/SpecialPromotionsService";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";
import { SpecialPromotionModel, SpecialPromotionsCollectionModel } from "@store/Types/SpecialPromotionModel";

type Parameter = HasOnSuccess<SpecialPromotionModel[]>;
type Props = StoreHandlerProps;

type HandlerType = ApiHandler<Parameter, SpecialPromotionsCollectionModel, Props>;


export const RequestDataFromApi: HandlerType = async props => {
    try {
        const result = await getSpecialPromotions();
        props.apiResult = result;
    } catch (error) {
        // we do nothing, we just wont show any promotion.
    }
};

export const DispatchCompleteLoadSpecialPromotions: HandlerType = props => {
    if (props.apiResult?.promotions) {
        props.dispatch({
            type: "Store/Data/SpecialPromotions/CompleteLoadSpecialPromotions",
            specialPromotions: props.apiResult.promotions,
        });
    }
};

export const chain = [
    RequestDataFromApi,
    DispatchCompleteLoadSpecialPromotions,
];

const loadSpecialPromotions = createHandlerChainRunner(chain, "LoadSpecialPromotions");
export default loadSpecialPromotions;
